export const MR_EXCEL_SHORTCUT_CATEGORY_META = {
  "File": {
    "id": "file",
    "icon": "▤",
    "intro": "Open, save, print, and close workbooks without leaving the keyboard."
  },
  "Ribbon": {
    "id": "ribbon",
    "icon": "⌁",
    "intro": "Control Ribbon commands and move between interface controls."
  },
  "General": {
    "id": "general",
    "icon": "◇",
    "intro": "Handle everyday commands such as undo, copy, paste, find, and charts."
  },
  "Tables and Filters": {
    "id": "tables-and-filters",
    "icon": "▦",
    "intro": "Create tables, control filters, and work inside structured data."
  },
  "Drag and Drop": {
    "id": "drag-and-drop",
    "icon": "↔",
    "intro": "Move, copy, insert, or duplicate cells and worksheets with the mouse."
  },
  "Navigation": {
    "id": "navigation",
    "icon": "➜",
    "intro": "Move quickly through cells, screens, regions, and worksheet boundaries."
  },
  "Selection": {
    "id": "selection",
    "icon": "▧",
    "intro": "Select rows, columns, worksheets, and separate ranges efficiently."
  },
  "Active Cell": {
    "id": "active-cell",
    "icon": "◎",
    "intro": "Control which cell is active inside a selected range."
  },
  "Extend Selection": {
    "id": "extend-selection",
    "icon": "↗",
    "intro": "Expand a selection by cells, screens, rows, or data boundaries."
  },
  "Select Special": {
    "id": "select-special",
    "icon": "✦",
    "intro": "Select visible cells, precedents, dependents, differences, and regions."
  },
  "Cell Edit Mode": {
    "id": "cell-edit-mode",
    "icon": "✎",
    "intro": "Edit cell contents and move or select text inside a cell."
  },
  "Entering Data": {
    "id": "entering-data",
    "icon": "⌨",
    "intro": "Enter, repeat, fill, and transform data more efficiently."
  },
  "Formatting": {
    "id": "formatting",
    "icon": "A",
    "intro": "Apply font, alignment, and general cell formatting commands."
  },
  "Number Formatting": {
    "id": "number-formatting",
    "icon": "123",
    "intro": "Apply common numeric display formats instantly."
  },
  "Borders": {
    "id": "borders",
    "icon": "□",
    "intro": "Add, remove, and control worksheet borders."
  },
  "Formulas": {
    "id": "formulas",
    "icon": "ƒx",
    "intro": "Create, calculate, inspect, and manage formulas and names."
  },
  "Grid Operations": {
    "id": "grid-operations",
    "icon": "▥",
    "intro": "Insert, delete, hide, group, and zoom worksheet structures."
  },
  "Pivot Tables": {
    "id": "pivot-tables",
    "icon": "◫",
    "intro": "Select, group, chart, and manage PivotTable elements."
  },
  "Workbook": {
    "id": "workbook",
    "icon": "▣",
    "intro": "Move between worksheets, panes, workbooks, and workbook windows."
  },
  "Dialog Boxes": {
    "id": "dialog-boxes",
    "icon": "◌",
    "intro": "Move through and confirm settings inside Excel dialog boxes."
  },
  "Other": {
    "id": "other",
    "icon": "•••",
    "intro": "Use spelling, comments, macros, Power Query, VBA, and object commands."
  }
};
